module.exports = __webpack_public_path__ + "static/media/morewise.7a212bf4.png";